import React from 'react';
import SimpleMap from './Components/SimpleMap';
import CardBox from 'components/CardBox';
import ContainerHeader from 'components/ContainerHeader';


const Simple = ({match}) => {
    return (
        <div className="animated slideInUpTiny animation-duration-3">
            <ContainerHeader title="Simple Map" match={match}/>

            <div className="row">
                <CardBox styleName="col-lg-12">
                    <SimpleMap />
                </CardBox>
            </div>
        </div>
    );
};

export default Simple;



// WEBPACK FOOTER //
// ./app/routes/map/routes/simple/index.js